import {any} from 'ramda';
import {combineLatest, map, Observable} from 'rxjs';
import Decimal, {DecimalSource} from './break_infinity';

export function gt(b: DecimalSource) {
  return (a: Decimal) => a.gt(b);
}

export function gte(b: DecimalSource) {
  return (a: Decimal) => a.gte(b);
}
export function lt(b: DecimalSource) {
  return (a: Decimal) => a.lt(b);
}
export function lte(b: DecimalSource) {
  return (a: Decimal) => a.lte(b);
}

export function eq(b: Decimal, a: Decimal): boolean;
export function eq(b: Decimal): (a: Decimal) => boolean;
export function eq(b: Decimal, a?: Decimal) {
  if (a) return new Decimal(a).eq(b);
  return (a: Decimal) => a.eq(b);
}

export function neq(b: DecimalSource) {
  return (a: Decimal) => a.neq(b);
}

/** Mask for Decimal.max to allow for D.max and some type issues. */
export function max(a: Decimal, b: Decimal): Decimal {
  return Decimal.max(a, b);
}
export function times(b: DecimalSource): (a: Decimal) => Decimal {
  return (a: Decimal) => a.times(b);
}

export function div(b: DecimalSource): (a: Decimal) => Decimal {
  return (a: Decimal) => a.div(b);
}

/** Mask for Decimal.add to allow for D.add and some type issues. */
export function add(a: Decimal, b: Decimal): Decimal {
  return Decimal.add(a, b);
}

export function sum(values: Decimal[]): Decimal {
  return values.reduce(add);
}

export function sum$(observables: Observable<Decimal>[]): Observable<Decimal> {
  return combineLatest(observables).pipe(map(sum));
}

export function product(values: Decimal[]): Decimal {
  return values.reduce(Decimal.times);
}

export function product$(
  observables: Observable<Decimal>[]
): Observable<Decimal> {
  return combineLatest(observables).pipe(map(product));
}

export function mean(values: DecimalSource[]): Decimal {
  return sum(values.map((d) => new Decimal(d))).div(values.length);
}
